import axios from '@/utils/request';

let prefix1 = process.env.VUE_APP_API_PREFIX_1;
let prefix = process.env.VUE_APP_API_PREFIX_2;

// 获取系统设置
const GetSetting = params => {
  return axios.get(prefix + '/GetSetting', {
    params
  });
};

// 设置系统信息
const SetSetting = data => {
  return axios.post(prefix + '/SetSetting', data);
};

// 发送测试邮件
const SendTestEmail = data => {
  return axios.post(prefix + '/SendTestEmail', data);
};

// 获取证书信息
const LicenseInfo = data => {
  return axios.post(prefix1 + '/license/LicenseInfo', data);
};

// 获取系统设置单独项
const GetSettingHideValue = params => {
  return axios.get(prefix + '/GetSettingHideValue', {
    params
  });
};

// 重新生成API_KEY
const ResetApikey = data => {
  return axios.post(prefix + '/ResetApikey', data);
};

// 上传文件
const UploadFile = data => {
  return axios.request({
    method: 'POST',
    url: prefix + '/UploadFile',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export { GetSetting, SetSetting, SendTestEmail, LicenseInfo, GetSettingHideValue, ResetApikey, UploadFile };
